module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compose preview",
    attrs: {
      "id": 'template-preview-' + _vm.template.id
    }
  }, [_c('div', {
    staticClass: "full"
  }, [_c('div', {
    staticClass: "title",
    class: _vm.template.kind
  }, [_c('span', [_vm._v(_vm._s(_vm.template.name))]), _c('span', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.template.email_statistic.formattedPercentage(_vm.template.connectedCount())))]), _c('span', {
    staticClass: "icon glyphicon glyphicon-transfer"
  })]), (_vm.template.kind == 'email') ? _c('span', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.template.email_statistic.replyPercentage()))]), _c('span', {
    staticClass: "icon glyphicon glyphicon-share-alt"
  })]) : _vm._e(), (_vm.template.kind == 'email') ? _c('span', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.template.email_statistic.openPercentage()))]), _c('span', {
    staticClass: "icon glyphicon glyphicon-envelope"
  })]) : _vm._e()]), _c('div', {
    staticClass: "info"
  }, [(_vm.template.subject && _vm.template.kind == "email") ? _c('div', {
    staticClass: "info-group subject"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('template.attributes.subject')))]), _c('span', [_vm._v(_vm._s(_vm.template.subject))])]) : _vm._e(), _c('div', {
    staticClass: "info-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.template.contentLabel()))]), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.template.body)
    }
  })]), _c('div', {
    staticClass: "clear"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1a53bd4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/preview.vue
// module id = 1230
// module chunks = 1